import { GetSupportedLoyaltyProgramsState } from './getSupportedLoyaltyPrograms.types'

const initialState: GetSupportedLoyaltyProgramsState = {
  loading: false,
  error: null,
  success: null
  // Initialize any additional state properties here
}

export default initialState
